import { render, staticRenderFns } from "./handle-business.vue?vue&type=template&id=1c7386c3&scoped=true&"
import script from "./handle-business.vue?vue&type=script&lang=js&"
export * from "./handle-business.vue?vue&type=script&lang=js&"
import style0 from "./handle-business.vue?vue&type=style&index=0&id=1c7386c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7386c3",
  null
  
)

export default component.exports